module.exports = __webpack_public_path__ + "img/icon_img8.f7cda547.png";